import type { Props } from '..'
import type { ReactElement } from 'react'

const SubtitleIcon = ({ className, color, onClick, size }: Props): ReactElement => {
  return (
    <svg
      className={className}
      fill="none"
      height={size}
      onClick={onClick}
      role="icon"
      viewBox="0 0 21 21"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect fill={color} height="21" rx="5" width="21" />
      <path d="M7.54 16V7.15H4.06V5.5H12.97V7.15H9.49V16H7.54Z" fill="#E9E9E9" />
      <path d="M13.28 16V10.32H11.04V9H17.14V10.32H14.9V16H13.28Z" fill="#E9E9E9" />
    </svg>
  )
}

export default SubtitleIcon
